<template>
  <b-modal
    id="cancellation-terms-modal"
    ref="cancellationTermsModal"
    hide-header
    hide-footer
    centered
    size="lg"
    body-class="p-4"
  >
    <button
      type="button"
      class="cancellation-modal__close"
      aria-label="Fechar"
      @click="close"
    >
      &times;
    </button>

    <h5 class="cancellation-modal__title">
      Antes de concluir, leia e concorde com o termo de aceite
    </h5>

    <div class="cancellation-modal__term" @click="acceptedTerm1 = !acceptedTerm1">
      <b-form-checkbox
        v-model="acceptedTerm1"
        class="cancellation-modal__checkbox"
        @click.native.stop
      />
      <p class="cancellation-modal__term-text">
        <strong>
          Declaro que a garantia nº {{ policyNumber }}, pode ser cancelada, pois o risco da
          ação judicial foi extinto e/ou a apólice foi substituída por outra garantia suficiente
          e devidamente aceita pelo juízo/Segurado.
        </strong>
        Declarado, ainda, que possuo documentação que evidencia referida extinção ou substituição,
        obrigando-me a disponibilizá-la à seguradora sempre que solicitado por esta.
        <strong>
          Declaro estar ciente que, efetuado o cancelamento, a garantia, deixará de produzir
          qualquer efeito legal
        </strong>, não podendo a seguradora ser responsabilizada e obrigada por eventos que
        envolvam a garantia.
        <strong>Toda e qualquer discussão que possa surgir</strong>, em qualquer jurisdição,
        <strong>
          será exclusivamente de minha responsabilidade, seja em nome próprio, ou em nome de
          terceiro, ficando a Junto Seguros S/A isenta de qualquer ônus e obrigações decorrentes
          da garantia.
        </strong>
      </p>
    </div>

    <div class="cancellation-modal__term" @click="acceptedTerm2 = !acceptedTerm2">
      <b-form-checkbox
        v-model="acceptedTerm2"
        class="cancellation-modal__checkbox"
        @click.native.stop
      />
      <p class="cancellation-modal__term-text">
        <strong>Declaro que as informações prestadas são verídicas e irretratáveis</strong>,
        sujeitando-me às cominações legais se constatada qualquer inveracidade.
      </p>
    </div>

    <div class="cancellation-modal__actions">
      <b-button
        block
        size="lg"
        variant="primary"
        class="cancellation-modal__btn-confirm"
        :disabled="!allTermsAccepted"
        @click="confirm"
      >
        Cancelar documento
      </b-button>
      <b-button
        block
        size="lg"
        variant="outline-secondary"
        class="cancellation-modal__btn-back"
        @click="close"
      >
        Voltar
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "CancellationTermsModal",
  props: {
    policyNumber: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    acceptedTerm1: false,
    acceptedTerm2: false,
  }),
  computed: {
    allTermsAccepted() {
      return this.acceptedTerm1 && this.acceptedTerm2;
    },
  },
  methods: {
    open() {
      this.acceptedTerm1 = false;
      this.acceptedTerm2 = false;
      this.$bvModal.show("cancellation-terms-modal");
    },
    close() {
      this.$bvModal.hide("cancellation-terms-modal");
    },
    confirm() {
      this.$emit("confirmed");
      this.close();
    },
  },
};
</script>

<style scoped>
.cancellation-modal__close {
  position: absolute;
  top: 1rem;
  right: 1.25rem;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  color: #6c757d;
  cursor: pointer;
  z-index: 1;
}
.cancellation-modal__close:hover {
  color: #343a40;
}

.cancellation-modal__title {
  font-weight: 700;
  text-align: center;
  margin-bottom: 1.75rem;
  padding-right: 2rem;
  font-size: 1.05rem;
  color: #212529;
}

.cancellation-modal__term {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.375rem;
  transition: background-color 0.15s;
}
.cancellation-modal__term:hover {
  background-color: #f8f9fa;
}

.cancellation-modal__checkbox {
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.cancellation-modal__term-text {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #495057;
}

.cancellation-modal__actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  margin-top: 1.75rem;
  padding: 0 2rem;
}

.cancellation-modal__btn-confirm,
.cancellation-modal__btn-back {
  width: 100%;
  max-width: 28rem;
  font-size: 1rem;
}

.cancellation-modal__btn-confirm:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
</style>
